"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanApply = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var LoanApply = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(LoanApply, _super);
    function LoanApply() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷借钱接口';
        _this.code = '101129';
        _this.desc = '现金贷借钱接口';
        _this.requestParams = new cashLoanAuth_1.LoanApplyRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return LoanApply;
}(service_1.BaseService));
exports.LoanApply = LoanApply;
//# sourceMappingURL=loanApply.js.map